<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import TransferReceiptsRequest from 'App/users/services/TransferReceiptsRequest';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import ReceiptDownloadColumnVue from 'App/users/components/columns/ReceiptDownloadColumn.vue';

export default {
  name: 'UserTransferReceiptList',
  extends: CrudListVue,
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    requestClass: TransferReceiptsRequest,
    hideEdit: true,
    hideDelete: true,
    headers: [
      {
        text: 'Comprovante',
        value: 'receiptFilename',
      },
      {
        text: 'Criado em',
        value: 'createdAt',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Baixar',
        value: 'receiptFilename',
        component: ReceiptDownloadColumnVue,
      },
    ],
  }),
  computed: {
    clientId() {
      return this.value;
    },
  },
  methods: {
    prepareRequest(params = {}) {
      return this.requestClass.list({
        ClientId: this.clientId,
        ...params,
      });
    },
  },
};
</script>
